import React from "react";
import "./style.css";

const Loader = () => (
  <div className="loader-container">
    <div className="loader-spinner"></div>
  </div>
);

export const ButtonLoader = () => (
  <div className="button-loader">
    <div className="loader-spinner-small"></div>
  </div>
);

export default Loader;
